import { render, staticRenderFns } from "./PortfolioIndex.vue?vue&type=template&id=a7b29aac&"
import script from "./PortfolioIndex.vue?vue&type=script&lang=js&"
export * from "./PortfolioIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports